var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyContractDeployments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 33.3333C60 29.6514 62.9848 26.6666 66.6667 26.6666C70.3486 26.6666 73.3333 29.6514 73.3333 33.3333V73.3332H93.3333V46.6666C93.3333 42.9847 96.3181 39.9999 100 39.9999C103.682 39.9999 106.667 42.9847 106.667 46.6666V73.3332H133.333C137.015 73.3332 140 76.318 140 79.9999C140 83.6818 137.015 86.6666 133.333 86.6666H106.667V113.333C106.667 117.015 103.682 120 100 120C96.3181 120 93.3333 117.015 93.3333 113.333V86.6666L73.3333 86.6666V126.667C73.3333 130.348 70.3486 133.333 66.6667 133.333C62.9848 133.333 60 130.348 60 126.667V86.6666H26.6667C22.9848 86.6666 20 83.6818 20 79.9999C20 76.318 22.9848 73.3332 26.6667 73.3332L60 73.3332V33.3333Z",
    fill: "#22252C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 39.8985C20 27.1307 31.8011 17.6321 44.2739 20.3605L124.274 37.8605C133.456 39.869 140 47.9997 140 57.3985V102.601C140 112 133.456 120.131 124.274 122.139L44.2739 139.639C31.8011 142.368 20 132.869 20 120.101V39.8985ZM41.4246 33.3859C37.267 32.4764 33.3333 35.6426 33.3333 39.8985V120.101C33.3333 124.357 37.267 127.523 41.4247 126.614L121.425 109.114C124.485 108.444 126.667 105.734 126.667 102.601V57.3985C126.667 54.2656 124.485 51.5554 121.425 50.8859L41.4246 33.3859Z",
    fill: "#22252C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyContractDeployments);
export default __webpack_public_path__ + "static/media/empty-contract-deployments.6417fc7839e4b00107d17dbcf9273072.svg";
export { ForwardRef as ReactComponent };